import { GiCheckMark } from 'react-icons/gi';
import { toast } from 'react-toastify';
import { useAuthContext } from '../../../contexts/AuthProvider';
import { useBookingContext } from '../../../contexts/BookingProvider';
import {
  AppointmentSlot,
  AvailableAssociate,
} from '../../../types/appointments';
import { Client } from '../../../types/users';

const BookingAvailableDiv = ({
  date,
  associate,
  partialTimeSlots,
}: {
  date: string;
  associate: AvailableAssociate;
  partialTimeSlots: Array<AppointmentSlot>;
}) => {
  // integration of context hooks here
  const {
    setShowAvailableSlotModal,
    setShowUpdateClientModal,
    setPartialTimeSlots,
    setSearchDate,
    setSelectedAssociate,
  } = useBookingContext();
  const { currentUserType, currentUser } = useAuthContext();

  console.log('PARTIAL TIME SLOTS: ', partialTimeSlots);

  // rendering booking available div component here
  return (
    <>
      <div
        onClick={() => {
          if (
            currentUserType === 'client' &&
            !(currentUser as Client).is_profile_complete
          ) {
            toast.warn('Please, complete your profile first!');
            setShowUpdateClientModal(true);

            return;
          }

          setSearchDate(date);
          setShowAvailableSlotModal(true);
          setSelectedAssociate(associate);
          setPartialTimeSlots(partialTimeSlots);
        }}
        className='flex items-center justify-center bg-base-light-green/30 py-3 cursor-pointer hover:opacity-70 active:scale-95 duration-300'
      >
        <GiCheckMark className='size-5 text-base-dark-green' />
      </div>
    </>
  );
};

export default BookingAvailableDiv;
